import type {
  ActivitySessionConfig,
  ActivitySessionFormat,
} from "@/db/schema/activities";
import { DEFAULT_ACTIVITY_SESSION_CONFIG } from "@/db/schema/activities";
import type { ActivityDefinition } from "@/lib/activities";

export { DEFAULT_ACTIVITY_SESSION_CONFIG } from "@/db/schema/activities";

export function getActivitySessionConfig(
  activity: ActivityDefinition | undefined | null,
): ActivitySessionConfig {
  return activity?.sessionConfig ?? DEFAULT_ACTIVITY_SESSION_CONFIG;
}

export function getActivitySessionRules(
  activity: ActivityDefinition | undefined | null,
) {
  return activity?.rules ?? null;
}

/**
 * Get participant range for a specific game format
 */
export function getParticipantRange(
  config: ActivitySessionConfig,
  format: ActivitySessionFormat,
): { min: number; max: number } {
  return config.participantRange[format] ?? { min: 1, max: 50 };
}

export function getSessionParticipantRange(
  activity: ActivityDefinition | undefined | null,
  format: ActivitySessionFormat | null | undefined,
): { min: number; max: number } {
  const rules = getActivitySessionRules(activity);
  if (!rules || !format) {
    return { min: 1, max: 50 };
  }

  return rules.session.participantRange[format] ?? { min: 1, max: 50 };
}

export function getDefaultSessionFormat(
  activity: ActivityDefinition | undefined | null,
): ActivitySessionFormat {
  const rules = getActivitySessionRules(activity);

  return rules?.session.defaultFormat ?? "group";
}
